export const COLLAPSE_MENU = "COLLAPSE_MENU"
export const COLLAPSE_MENU_DONE = "COLLAPSE_MENU_DONE"